import { SegmentControl } from "@/components/SegmentControl";
import type { BlokSegmentControl } from "@/storyblok";
import { StoryblokComponentList, type BlokProps } from "@frend-digital/storyblok";

export const SegmentControlBlok = ({ blok, preview }: BlokProps<BlokSegmentControl>) => {
	return (
		<SegmentControl segments={blok}>
			<StoryblokComponentList preview={preview} bloks={blok.blocks || []} />
		</SegmentControl>
	);
};
